import React from 'react'

/**
 * Picks how wide the dashboard's three columns are.
 *
 * Each option draws itself in proportion, so the control shows the layout you
 * are choosing rather than naming it and hoping. Widths are a dashboard level
 * setting, not a per-widget span: the columns stack independently so a tall
 * widget never pushes its neighbours down, and CSS cannot combine independent
 * column stacking with column spanning.
 */
const ColumnLayoutPicker = ({ layouts = [], value, onChange }) => (
  <span role="group" aria-label="Column widths" className="flex items-center gap-1">
    {layouts.map((layout) => {
      const selected = layout.key === value

      return (
        <button
          key={layout.key}
          type="button"
          aria-pressed={selected}
          title={layout.label}
          onClick={() => onChange(layout.key)}
          className={`flex h-6 w-10 items-center gap-px rounded border p-1 transition focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 ${
            selected
              ? 'border-primary bg-primary'
              : 'border-gray-400 bg-white hover:border-primary'
          }`}
        >
          {layout.fractions.map((fraction, i) => (
            <span
              key={i}
              style={{ flexGrow: fraction }}
              className={`h-full rounded-sm ${selected ? 'bg-white' : 'bg-gray-400'}`}
            />
          ))}
          <span className="sr-only">{layout.label}</span>
        </button>
      )
    })}
  </span>
)

export default ColumnLayoutPicker
